
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25.702","height":"18.367"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.608 .599)","fill":"none","stroke":"#959da1","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"4.455","cy":"4.455","r":"4.455","transform":"rotate(-77.025 10.465 -1.953)"}}),_c('path',{attrs:{"d":"M6.071 17.159s1.108-4.329 9.289-4.329 9.138 4.329 9.138 4.329"}}),_c('ellipse',{attrs:{"cx":"2.335","cy":"2.336","rx":"2.335","ry":"2.336","transform":"rotate(-77.025 7.365 3.496)"}}),_c('path',{attrs:{"d":"M0 14.622s.632-2.468 5.3-2.468a6.806 6.806 0 014.342 1.224"}})])])
          )
        }
      }
    